<style>
/* Display as block element */
:host {
    display: block;
}

:host([hidden]) {
    display: none;
}

.container {
    margin: 0;
    padding: 0;

    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    align-items: stretch;
    gap: 1rem;
}

.container > * {
    margin: 0;
}

.container.horizontal {
    flex-direction: row;
}
</style>
